import React, { useContext, useEffect, useState } from "react";
import styled, { css, keyframes } from "styled-components";

import { ShowLandingContext } from "./../Landing/ShowLandingContextWrapper";
import { CurrentThemeContext } from "./../common/ThemeContextWrapper";
import { getRandomNumber } from "./../common/SeasonalFlavor";

import BaseURL from "./../Unit/data/images/Hosting-BaseURL";
import SpriteImage from "../common/styles/SpriteImage";

const mechLogoImage = `${BaseURL}/text/lancer/Static.gif`;
const mechLogoStutter1 = `${BaseURL}/text/lancer/stutter 1.gif`;
const mechLogoStutter2 = `${BaseURL}/text/lancer/stutter 2.gif`;
const mechLogoStutter3 = `${BaseURL}/text/lancer/stutter 3.gif`;
const mechLogoStutter4 = `${BaseURL}/text/lancer/stutter 4.gif`;
const mechLogoStutter5 = `${BaseURL}/text/lancer/stutter 5.gif`;
const mechLogoStutter6 = `${BaseURL}/text/lancer/stutter 6.gif`;

const mechSubLogoImage = `${BaseURL}/text/lancer/Tabletop Minis.png`;
const mechSubLogoStatic = `${BaseURL}/text/lancer/Tabletop Minis Static.gif`;
const mechSubLogoStutter = `${BaseURL}/text/lancer/Tabletop Minis Stutter.gif`;

const mechLogoImages = [
    mechLogoStutter1,
    mechLogoStutter2,
    mechLogoStutter3,
    mechLogoStutter4,
    mechLogoStutter5,
    mechLogoStutter6,
];

const mechSubLogoImages = [
    mechSubLogoStatic,
    mechSubLogoStutter,
];

const HeaderImageWrapper = styled.div`
    position: relative;
    top: 0;
    left: 0;
    width: 478px;
    padding-bottom: ${props => props.showLanding ? "180px" : "0px"};

    @media only screen and (max-width: ${props => props.theme.mobileCutoffWidth}px) {
        max-width: 95vw;
    }
`;

HeaderImageWrapper.displayName = "HeaderImageWrapper";

const HeaderTextWrapper = styled(HeaderImageWrapper)`
    width: 600px;
`;

HeaderTextWrapper.displayName = "HeaderTextWrapper";

const bounce = keyframes`
    0% {
        transform: translateY(-3px);
    }
    25% {
        transform: translateY(-3px);
    }
    45% {
        transform: translateY(0px);
    }
    55% {
        transform: translateY(0px);
    }
    100% {
        transform: translateY(-3px);
    }
`;

const bounceMixin = css`
    animation: ${bounce} infinite 3.5s linear;
`;

const HeaderLogo = styled(SpriteImage)`
    ${props => props.showLanding ? "animation: none" : bounceMixin};
    max-width: 100%;
    position: absolute;
    top: 5;
    left: 5px;
    z-index: 2;
`;

HeaderLogo.displayName = "HeaderLogo";

const HeaderText = styled.h1`
    max-width: 100%;
    position: absolute;
    top: ${props => props.showLanding ? "50px" : "5px"};
    left: ${props => props.showLanding ? "140px" : "5px"};
    z-index: 2;
    font-size: 40px;
    color: #666;
    font-weight: bolder;
    font-family: Arial, Helvetica, sans-serif;
    transition-duration: ${props => props.theme.landingTransitionDuration}s;
    transition-property: top, left;

    span {
        top: 25;
        font-size: 20px;
        font-weight: normal;
    }
`;

HeaderText.displayName = "HeaderText";

const SubHeaderText = styled(HeaderText)`
    opacity: ${props => props.showLanding ? 0 : 1};
    transition-duration: ${props => props.theme.landingTransitionDuration - 2}s;
    transition-property: opacity;
    transition-delay: ${props => props.theme.landingTransitionDuration}s;
    top: 45px;
    left: 5px;
    font-size: 20px;
    font-weight: normal;

    @media only screen and (max-width: ${props => props.theme.mobileCutoffWidth}px) {
        display: none;
    }
`;

SubHeaderText.displayName = "SubHeaderText";

const fade = keyframes`
    0% {
        opacity: 0.5;
    }
    25% {
        opacity: 0.5;
    }
    45% {
        opacity: 1;
    }
    55% {
        opacity: 1;
    }
    100% {
        opacity: 0.5;
    }
`;

const fadeMixin = css`
    animation: ${fade} infinite 3.5s linear;
`;

const HeaderLogoShadow = styled(HeaderLogo)`
    ${props => props.showLanding ? "animation: none" : fadeMixin};
    top: 5px;
    left: 5px;
    z-index: 1;
`;

HeaderLogoShadow.displayName = "HeaderLogoShadow";

const SubheaderImage = styled(HeaderLogo)`
    animation: none;
    opacity: ${props => props.showLanding ? 0 : 1};
    transition-duration: ${props => props.theme.landingTransitionDuration - 2}s;
    transition-property: opacity;
    transition-delay: ${props => props.theme.landingTransitionDuration}s;
    top: 105px;
    left: 60px;

    @media only screen and (max-width: ${props => props.theme.mobileCutoffWidth}px) {
        display: none;
    }
`;

SubheaderImage.displayName = "SubheaderImage";

const MechHeaderLogo = styled.img`
    animation: none;
    max-width: 100%;
    position: absolute;
    top: 5;
    left: 5px;
    z-index: 2;
`;

MechHeaderLogo.displayName = "MechHeaderLogo";

const MechSubheaderImage = styled.img`
    animation: none;
    opacity: ${props => props.showLanding ? 0 : 1};
    position: absolute;
    transition-duration: ${props => props.theme.landingTransitionDuration - 2}s;
    transition-property: opacity;
    transition-delay: ${props => props.theme.landingTransitionDuration}s;
    top: 120px;
    left: 60px;

    @media only screen and (max-width: ${props => props.theme.mobileCutoffWidth}px) {
        display: none;
    }

    &.lvoid {
        filter: drop-shadow(0 0 0.1rem #000);
    }
`;

MechSubheaderImage.displayName = "MechSubheaderImage";

function HeaderImage() {
    const { showLanding } = useContext(ShowLandingContext);
    const { currentTheme } = useContext(CurrentThemeContext);

    const [ logoStaticIndex, setLogoStaticIndex ] = useState(0);
    const [ displayLogoStatic, setDisplayLogoStatic ] = useState(false);
    const [ subLogoStaticIndex, setSubLogoStaticIndex ] = useState(0);
    const [ displaySubLogoStatic, setDisplaySubLogoStatic ] = useState(false);

    // useEffect(() => {
    //     imagesToPreload.forEach((imageToPreload) => {
    //         const img = new Image();
    //         img.src = imageToPreload;
    //     });
    // }, []);

    useEffect(() => {
        if (currentTheme === "mech" || currentTheme === "lvoid" || currentTheme === "dvoid") {
            if (displayLogoStatic) {
                const timer = setTimeout(() => {
                    setDisplayLogoStatic(false);
                }, 400);

                return () => clearTimeout(timer);
            } else {
                const timer = setTimeout(() => {
                    setLogoStaticIndex(getRandomNumber(mechLogoImages.length, 0));
                    setDisplayLogoStatic(true);
                }, getRandomNumber(5, 1) === 1 ? getRandomNumber(2000, 1000) : getRandomNumber(10000, 6000));

                return () => clearTimeout(timer);
            }
        }
    }, [currentTheme, displayLogoStatic, setDisplayLogoStatic]);

    useEffect(() => {
        if (currentTheme === "mech" || currentTheme === "lvoid" || currentTheme === "dvoid") {
            if (displaySubLogoStatic) {
                const timer = setTimeout(() => {
                    setDisplaySubLogoStatic(false);
                }, 400);

                return () => clearTimeout(timer);
            } else {
                const timer = setTimeout(() => {
                    setSubLogoStaticIndex(getRandomNumber(mechSubLogoImages.length, 0));
                    setDisplaySubLogoStatic(true);
                }, getRandomNumber(5, 1) === 1 ? getRandomNumber(2000, 1000) : getRandomNumber(10000, 6000));

                return () => clearTimeout(timer);
            }
        }
    }, [currentTheme, displaySubLogoStatic, setDisplaySubLogoStatic]);

    if (currentTheme === "lvoid" || currentTheme === "dvoid") {
        return (
            <HeaderTextWrapper showLanding={showLanding}>
                <HeaderText className={currentTheme} showLanding={showLanding}>RETROGRADE //</HeaderText>
                <SubHeaderText className={currentTheme} showLanding={showLanding}>TABLETOP MINIATURES</SubHeaderText>
            </HeaderTextWrapper>
        );
    }

    if (currentTheme === "mech") {
        return (
            <HeaderImageWrapper showLanding={showLanding}>
                <MechHeaderLogo
                    src={displayLogoStatic ? mechLogoImages[logoStaticIndex] : mechLogoImage}
                    alt="RetroGrade Logo"
                    showLanding={showLanding}
                />

                <MechSubheaderImage
                    className={currentTheme}
                    src={displaySubLogoStatic ? mechSubLogoImages[subLogoStaticIndex] : mechSubLogoImage}
                    alt="TableTop Minis"
                    showLanding={showLanding}
                />
            </HeaderImageWrapper>
        );
    }

    return (
        <HeaderImageWrapper showLanding={showLanding}>
            <HeaderLogo
                className={currentTheme === "winter" ? "bg-retrograde-logo-red" : "bg-retrograde-logo"}
                showLanding={showLanding}
            />
            <HeaderLogoShadow
                className="bg-logo-shadow"
                showLanding={showLanding}
            />
            <SubheaderImage
                className={currentTheme === "winter" ? "bg-tabletop-minis-logo-red" : "bg-tabletop-minis-logo"}
                showLanding={showLanding}
            />
        </HeaderImageWrapper>
    );
}

export default HeaderImage;
